import { BREAKPOINTS, createMostlyFluidVariantComponents } from '../setup-factories'
import styled from 'styled-components/macro'

const { MostlyFluidPageInternal } = createMostlyFluidVariantComponents({
  PageInternal: {
    widths: ['50%'],
    horizontalPadding: '24px',
    verticalPadding: '0',
    breakpoints: { medium: { widths: ['100%'] }, small: { widths: ['100%'] } }
  }
})
export const MostlyFluidPage = styled(MostlyFluidPageInternal)`
  height: 100%;
  > * {
    height: 100%;
  }
  @media (max-width: ${BREAKPOINTS.large}px) {
    > *:first-child {
      height: 0;
    }
  }
`
